export const SHOP_BY_PRICE_AMOUNTS = ['5', '15', '25', '50', '100', '150'];
export const MAGENTO_NEW_ARRIVALS_CATEGORIES = [
    'new-pet',
    'lifestyle',
    'new-baby-and-kids',
    'new-fashion-and-beauty',
    'new-home',
    'new-electronics',
];
